import { descriptionConstants } from '../constants';

export function descriptions(state = {}, action) {
  switch (action.type) {
    case descriptionConstants.GETALL_REQUEST:
      return {
        state,
        loading: true
      }
    case descriptionConstants.GETALL_SUCCESS:
      return {
        ...state,
        items: action.items,
        total: action.total,
        loading: false
      }
    case descriptionConstants.GETALL_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    default:
      return state;
  }
}

export function AddDescription(state = {}, action) {
  switch (action.type) {
    case descriptionConstants.ADD_REQUEST:
      return {
        state,
        loading: true,
      }
    case descriptionConstants.ADD_SUCCESS:
      return {
        ...state,
        status: action.status,
        loading: false
      }
    case descriptionConstants.ADD_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        status: false
      };
    default:
      return state;
  }
}

export function GetDescription(state = {}, action) {
  switch (action.type) {
    case descriptionConstants.GET_REQUEST:
      return {
        state,
        loading: true,
      }
    case descriptionConstants.GET_SUCCESS:
      return {
        ...state,
        item: action.item,
        loading: false
      }
    case descriptionConstants.GET_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

export function UpdateDescription(state = {}, action) {
  switch (action.type) {
    case descriptionConstants.UPDATE_REQUEST:
      return {
        state,
        loading: true,
      }
    case descriptionConstants.UPDATE_SUCCESS:
      return {
        ...state,
        status: action.status,
        loading: false
      }
    case descriptionConstants.UPDATE_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        status: false
      };
    default:
      return state;
  }
}